import { Button } from 'primereact/button';
import React, {
    forwardRef,
    useCallback,
    useContext,
    useEffect,
    useImperativeHandle,
    useRef,
    useState,
} from 'react';
import { useParams } from 'react-router-dom';
import { ApplicationContext } from '../../../../../config/Router';
import PageMessages from '../../../../../config/translations/PageMessages';
import { MultipageContext } from '../../../../../core/components/Multipage';
import metaService from '../../../../../service/MetaService';
import styles from './ApuracaoResultado.module.scss';
import CollapseMeta from './components/collapseMeta/CollapseMeta';
import TableApuracao from './components/tableApuracao/TableApuracao';

const ButtonApurar = forwardRef(({ inputsRef, loadMetas }, ref) => {
    const { modalApuracaoRef, confirmOkRef } = useContext(MultipageContext);
    const [disabled, setDisabled] = useState(true);
    const { situacaoIndicador } = useContext(ApplicationContext);

    useImperativeHandle(ref, () => ({ disabled, setDisabled }), [disabled]);

    return (
        <div className={`buttonsRight ${styles.buttonRight}`}>
            <Button
                icon="pi pi-sliders-h"
                label="Apurar Resultado da Meta"
                disabled={disabled}
                onClick={() => {
                    if (situacaoIndicador?.codgSituacaoIndicador !== 'ATIVO') {
                        confirmOkRef.current?.show(
                            PageMessages.sei.metasResultados.apurarResultado.indicadorNaoAtivo
                        );
                    } else {
                        const selected = Object.keys(inputsRef.current).find(
                            (name) => inputsRef.current[name].value !== ''
                        );

                        if (
                            inputsRef.current[selected]?.meta?.situacao?.codgSituacaoMeta !==
                            'VALIDADA'
                        ) {
                            confirmOkRef.current?.show(
                                PageMessages.sei.metasResultados.apurarResultado.metaNaoValidada
                            );
                        } else if (inputsRef.current[selected]?.meta?.apuracaoMeta !== null) {
                            confirmOkRef.current?.show(
                                PageMessages.sei.metasResultados.apurarResultado.apuracaoExistente
                            );
                        } else {
                            modalApuracaoRef.current.show({
                                meta: inputsRef.current[selected]?.meta,
                                loadMetas,
                            });
                        }
                    }
                }}
            />
        </div>
    );
});

function ApuracaoResultado() {
    const [metas, setMetas] = useState([]);
    const inputsRef = useRef({});
    const buttonRef = useRef(null);
    const { id: idIndicador } = useParams();

    const loadMetas = useCallback(async () => {
        const response = await metaService.list({
            params: { search: `indicador.id==${idIndicador}` },
        });
        setMetas(response);
    }, []);

    useEffect(() => {
        loadMetas();
    }, [loadMetas]);

    return (
        <>
            <ButtonApurar ref={buttonRef} loadMetas={loadMetas} inputsRef={inputsRef} />
            <div className={styles.containerMetas}>
                {metas.map((meta, i) => (
                    <CollapseMeta
                        key={i}
                        ref={(el) => (inputsRef.current[i] = el)}
                        onSave={loadMetas}
                        onChange={(value) => {
                            buttonRef.current.setDisabled(false);
                            Object.keys(inputsRef.current).forEach((name) => {
                                if (
                                    inputsRef.current[name].value !== '' &&
                                    inputsRef.current[name].value !== value
                                ) {
                                    inputsRef.current[name].setValue('');
                                }
                            });
                        }}
                        {...meta}
                    />
                ))}
            </div>
            <TableApuracao
                legend="Apurações de Resultados Avulsos"
                showDelete
                showOutrasApuracoes
                className={styles.table}
            />
        </>
    );
}

export default ApuracaoResultado;
